import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6b87b5d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "grid single",
  style: {"max-height":"40vh","overflow-y":"scroll"}
}
const _hoisted_2 = { class: "flex center align-center justify-center text-muted no-mobile" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"filter":"brightness(50%)"},
  src: "ico/stores.svg"
}, null, -1))
const _hoisted_4 = { class: "text-muted center" }
const _hoisted_5 = { class: "flex grow" }
const _hoisted_6 = { class: "flex g12" }
const _hoisted_7 = {
  key: 0,
  class: "flex grow align-center justify-center"
}
const _hoisted_8 = { class: "flex align-center g24" }
const _hoisted_9 = { class: "flex align-start justify-start settings-card" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex col g0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark bold" }, "Prix de la licence")
], -1))
const _hoisted_11 = { class: "flex align-center" }
const _hoisted_12 = { class: "settings-container bluebg" }
const _hoisted_13 = { class: "settings-card wrap g12 flex" }
const _hoisted_14 = { class: "flex justify-between align-center" }
const _hoisted_15 = { class: "settings-card" }
const _hoisted_16 = { class: "settings-card g12 flex" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted",
  style: {"white-space":"nowrap"}
}, "Démarrer la semaine le : ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeCheckboxGroup = _resolveComponent("SeCheckboxGroup")!
  const _component_SeLoadingIndicator = _resolveComponent("SeLoadingIndicator")!
  const _component_SeIllustration = _resolveComponent("SeIllustration")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "ownersModal",
      title: _ctx.Lang.getI18N('owners')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.owners, (owner) => {
            return (_openBlock(), _createBlock(_component_WideCard, {
              key: owner.ref?.id,
              icon: "/ico/account.svg",
              title: owner.name + ' ' + owner.surname,
              redirectPage: _ctx.role == _ctx.Role.Customer ? undefined : 'account',
              obj: owner
            }, {
              subtitle: _withCtx(() => [
                _createTextVNode(_toDisplayString(owner.email), 1)
              ]),
              footer: _withCtx(() => [
                _createVNode(_component_SeFadeButton, {
                  onClick: [
                    ($event: any) => (_ctx.removeOwner(owner)),
                    _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  ],
                  icon: "/ico/trash.svg"
                }, null, 8, ["onClick"]),
                _createElementVNode("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(owner.stores.length) + " ", 1),
                  _hoisted_3
                ])
              ]),
              _: 2
            }, 1032, ["title", "redirectPage", "obj"]))
          }), 128))
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Lang.getI18N("enter-the-email-of-the-user")) + " : ", 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_SeInput, {
            class: "grow",
            ref: "ownerName"
          }, null, 512),
          _createVNode(_component_SeButton, {
            onPress: _ctx.addOwner,
            class: "modal-valid"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ok")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      ref: "moduleModal",
      title: "Modules"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_ctx.Lang.getI18N("features-select")) + ":", 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_SeCheckboxGroup, {
            title: "Modules",
            class: "p12",
            ref: "modulesSelect",
            labelFunction: _ctx.getLabelFromI18N,
            items: _ctx.getModuleEnums()
          }, null, 8, ["labelFunction", "items"]),
          _createVNode(_component_SeCheckboxGroup, {
            title: "Extensions",
            class: "p12",
            ref: "extensionsSelect",
            labelFunction: _ctx.getLabelFromI18N,
            items: _ctx.getExtensionEnums()
          }, null, 8, ["labelFunction", "items"])
        ])
      ]),
      _: 1
    }, 512),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_SeLoadingIndicator)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_ReadonlyField, {
            locked: _ctx.tablet,
            class: "settings-header"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_SeIllustration, {
                  onFilePick: _ctx.onIllustrationChange,
                  src: _ctx.state.store!.illustration_url == null
          ? 'ico/store.svg'
          : _ctx.state.store!.illustration_url.get()
          
                }, null, 8, ["onFilePick", "src"]),
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_SeInput, {
                    modelValue: _ctx.licencePrice,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.licencePrice) = $event)),
                    ref: "licencePrice"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_SeFadeButton, {
                    onClick: _ctx.resetPriceOverride,
                    icon: "/ico/trash.svg"
                  }, null, 8, ["onClick"])
                ], 512), [
                  [_vShow, _ctx.role == _ctx.Role.Admin]
                ]),
                _withDirectives(_createVNode(_component_ToggleSwitch, {
                  modelValue: _ctx.state.store.demonstration_store,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.store.demonstration_store) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Etablissement Démo ")
                  ]),
                  _: 1
                }, 8, ["modelValue"]), [
                  [_vShow, _ctx.role == _ctx.Role.Admin]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_SeButton, {
                  onPress: _ctx.openOwnersModal,
                  icon: "/ico/profile.svg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("owners")), 1)
                  ]),
                  _: 1
                }, 8, ["onPress"]),
                _createVNode(_component_ReadonlyField, {
                  locked: _ctx.role != _ctx.Role.Distributor && _ctx.role != _ctx.Role.Admin
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_ToggleSwitch, {
                      modelValue: _ctx.state.store!.secureat_licence,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.store!.secureat_licence) = $event)),
                      ref: "toggleSecureatLicence"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("secureat-licence")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]), [
                      [_vShow, _ctx.toggleRight]
                    ])
                  ]),
                  _: 1
                }, 8, ["locked"]),
                _createVNode(_component_ToggleSwitch, {
                  modelValue: _ctx.state.store!.active,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.store!.active) = $event)),
                  auto: true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_SeButton, {
                  tooltip: _ctx.Lang.getI18N('save'),
                  ref: "modifyBtn",
                  onPress: _ctx.save,
                  icon: "/ico/save.svg"
                }, null, 8, ["tooltip", "onPress"])
              ])
            ]),
            _: 1
          }, 8, ["locked"]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ReadonlyField, {
              locked: _ctx.tablet,
              class: "flex align-start g24 wrap"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SeInput, {
                  placeholder: _ctx.Lang.getI18N('name'),
                  modelValue: _ctx.state.store!.name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.store!.name) = $event)),
                  ref: "name"
                }, null, 8, ["placeholder", "modelValue"]),
                _createVNode(_component_SeInput, {
                  placeholder: _ctx.Lang.getI18N('address'),
                  modelValue: _ctx.state.store!.address,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.store!.address) = $event)),
                  ref: "address"
                }, null, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }, 8, ["locked"]),
            _createVNode(_component_ReadonlyField, {
              locked: _ctx.tablet,
              class: "flex align-start g24 wrap"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SeInput, {
                  placeholder: _ctx.Lang.getI18N('postal-code'),
                  modelValue: _ctx.state.store!.postal_code,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.store!.postal_code) = $event)),
                  ref: "postalCode"
                }, null, 8, ["placeholder", "modelValue"]),
                _createVNode(_component_SeInput, {
                  modelValue: _ctx.state.store!.city,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.store!.city) = $event)),
                  placeholder: _ctx.Lang.getI18N('city'),
                  ref: "city"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["locked"]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_SeButton, {
                icon: "/ico/edit.svg",
                onPress: _ctx.openModulesModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("features")), 1)
                ]),
                _: 1
              }, 8, ["onPress"]),
              _createVNode(_component_ReadonlyField, {
                class: "flex justify-center",
                locked: _ctx.role != _ctx.Role.Distributor && _ctx.role != _ctx.Role.Admin
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ToggleSwitch, {
                    modelValue: _ctx.state.store!.manager_owned,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.store!.manager_owned) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("manager-owned")), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]), [
                    [_vShow, _ctx.toggleRight]
                  ])
                ]),
                _: 1
              }, 8, ["locked"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_SeButton, {
                  class: "w100",
                  onPress: _ctx.openAllergensView,
                  icon: "/ico/auditing.svg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("button-allergens-open")), 1)
                  ]),
                  _: 1
                }, 8, ["onPress"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_SeDropdown, {
                  modelValue: _ctx.state.store.week_start,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.store.week_start) = $event)),
                  titleFunc: _ctx.getWeekdayTitle,
                  class: "w100",
                  icon: "/ico/calendar.svg"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SeDropdownItem, { value: 0 }),
                    _createVNode(_component_SeDropdownItem, { value: 1 }),
                    _createVNode(_component_SeDropdownItem, { value: 2 }),
                    _createVNode(_component_SeDropdownItem, { value: 3 }),
                    _createVNode(_component_SeDropdownItem, { value: 4 }),
                    _createVNode(_component_SeDropdownItem, { value: 5 }),
                    _createVNode(_component_SeDropdownItem, { value: 6 })
                  ]),
                  _: 1
                }, 8, ["modelValue", "titleFunc"])
              ])
            ])
          ])
        ], 64))
  ], 64))
}